import ApiConnector         from '@/models/ApiConnector';
import { Collection }       from '@mathquis/modelx';
import { ConnectorResults } from '@mathquis/modelx';
import { Model }            from '@mathquis/modelx';
import { getLocale }        from '@widesk-core/locale';

export default class WebsiteConnector extends ApiConnector {
	protected _authorizationHeaderName = 'X-Platform-Authorization';
	protected _useMergePatch = true;
	public resultTotalPath = 'totalItems';
	protected _memberPath = 'member';
	protected _totalItemsPath = 'totalItems';

	public async list<T extends Model>(collection: Collection<T>, options: ConnectorListOptions = {}) {
		const customOptions = {
			...options,
			method: 'get',
			headers: {
				...options.headers,
				'X-LOCALE': options.translations || getLocale() || 'fr',
				'X-Include-Files': 'true',
			}};

		const response = await this.requestList(collection.path, customOptions);

		const data = response?.data?.member ?? response?.data?.data ?? response?.data;

		return new ConnectorResults(data || [], response);
	}

	protected request(path: string, options: Record<string, unknown> = {}) {
		const params = (options.params || {}) as any;

		if (params.itemsPerPage) {
			params.pagination = true;
		}

		return super.request(path, options);
	}
}
